/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecoveringProductLine } from '../../models/recovering-product-line';
import { UpdateRecoveringProductLineDto } from '../../models/update-recovering-product-line-dto';

export interface UpdateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params {
  id: number;
      body: UpdateRecoveringProductLineDto
}

export function updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProductLine>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveringProductLine>;
    })
  );
}

updateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine.PATH = '/api/mgmt/recovering-product-line/{id}';
